/**
 * @enum HttpStatus
 * @description Common Http Status. Für mehr Information :
 * https://en.wikipedia.org/wiki/List_of_HTTP_status_codes
 */
export enum HttpStatus {
  OK_200 = 200,
  NO_CONTENT_204 = 204,
  NOT_MODIFIED_304 = 304,
  BAD_REQUEST_400 = 400,
  UNAUTHORIZED_401 = 401,
  FORBIDDEN_403 = 403,
  NOT_FOUND_404 = 404,
  METHOD_NOT_ALLOWED_405 = 405,
  INTERNAL_SERVER_ERROR_500 = 500,
  SBB_LOGIN_ERROR_999 = 999,
  ESRI_JS_API_LOAD_ERROR_998 = 998,
  LOADING_USER_CONFIG_ERROR_997 = 997,
  LOADING_FEATURE_LAYER_ERROR_996 = 996,
}
